import React, {createContext, useReducer} from "react";
import Reducer from './Reducer'


const initialState = {
    LoginInfo: {SESSION_ID: '',LOGIN_NAME: "", PARTY_ID: '', LOCATION_ID: '', PARTY_NAME: '', COMPANY_ID: '', IMAGE_FOLDER_URL: ''},
    token: '',
    catalogueData: null, 
    filterData: null, 
    items: [], 
    loading: false, 
    hasMore: true, 
    pages: 1,
    errorMessage: null,
    cart: [],
    activeCatalogueId: 0,
    searchText: '',
    guid: '',
    drawerShow: false,
    catalogueStatus: null,
    defaultActiveSidebar: '',
    catalogueDrawer: false,
    lastScrollPosition: null,
    totalCartItem: 0,
    customCatalogue: null,
    mobileNumber: null,
    elasticFilterData: null,
    clearSearchText: null,
    groupPartyLoading : false,
    groupPartyList : [],
    groupPartyFilterHeading: null,
    partFilterState: null,
    template: null,
    sortFilterData: null,
    sortPartyList: null,
    searchMode: 'SET',
    allItemsData: null,
    sortFilterOfGroupItem: null,
    sortFilterOfGroupItemHeading: null,
    clearSortFilter: 'no',
    allGroupOptionLists: null,
    similarSearchUrl:null,
    similarItemAgg : null,
    similarItemData : null,
    documentList: null,
    quotationToken: '',
    searchByImage: false,
    searchByImageData: null,
    client_name: "MEHTA GOLD",
    top_search_count: 25,
    nav_from_to_sbi: "HOME_SBI", // MASTER_SBI , TRANS_SBI , STOCK_SBI 
    vt_mid_list:[]
};

const Store = ({children}) => {
    const [state, dispatch] = useReducer(Reducer, initialState);
    return (
        <GlobalContext.Provider value={[state, dispatch]}>
            {children}
        </GlobalContext.Provider>
    )
};

export const GlobalContext = createContext(initialState);

export default Store;